const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  COMMA
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Peru',
  code: 'PE',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    city: { label: 'Town' },
    stateCode: { label: 'Province', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address', COMMA, 'city'],
    ['zipCode'],
    ['stateCode']
  ],
  formFormat: [['company'], ['address', 'city'], ['zipCode', 'stateCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 15074'
    }
  ]
};
